module.exports = "/assets/images/ico-mapa.b425dbae.png";